import useSWR from "swr";

import { baseApi } from "../common/envUtils";
import httpClient from "../providers/httpClient";

export function useGlobalSettings() {
	const { data: settings, ...rest } = useSWR("globalSettings", async () => {
		const url = `${baseApi}/v2/users/settings/global`;
		const response = await httpClient(url, {
			method: "GET",
		});
		if (!response || response.status !== 200) {
			return null;
		}
		return response.json;
	});

	return { settings, ...rest };
}
